export default __webpack_public_path__ + "static/collaborative_work-610cd6d76d402bdcb239fbfe0b2f8ff7.png";